const Portfolio_data = [
    {
      id: 1,
      category: "DEVELOPMENT",
      totalLike: "600",
      title: "The services provide for design ",
      image: "./image/portfolio-01.jpg",
    },
    {
      id: 2,
      category: "APPLICATION",
      totalLike: "750",
      title: "Mobile app landing design & maintain",
      image: "./pic/pic2.jpg",
    },
    {
      id: 3,
      category: "PHOTOSHOP",
      totalLike: "630",
      title: "Logo design creativity & Application ",
      image: "./components/pic/pic1.jpg",
    },
    {
      id: 4,
      category: "FIGMA",
      totalLike: "360",
      title: "Mobile app landing design & Services",
      image: "./image/portfolio-04.jpg",
    },
    {
      id: 5,
      category: "WEB DESIGN",
      totalLike: "280",
      title: "Design for tecnology & services",
      image: "./image/portfolio-05.jpg",
    },
    {
      id: 6,
      category: "WEB DESIGN",
      totalLike: "690",
      title: "App for tecnology & services",
      image: "./image/portfolio-06.jpg",
    },
  ]
  export default Portfolio_data